import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { NEXT_STATIC_IMAGES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import HeroGrid from 'src/about/components/HeroGrid';
import styles from './Hero.module.scss';

const Hero: FC = () => {
  const [t] = useTranslation('about-page');

  return (
    <PitchPageLayout
      backgroundColor="ivory"
      variant="header"
    >
      <div className={styles.root}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={`${NEXT_STATIC_IMAGES}about/hero-graphic.svg`}
          width={187}
          height={80}
          alt={t('hero--graphic--alt')}
          loading="eager"
        />
        <div className={styles.title}>
          <Typography
            type="h1"
            size="display-4"
            sizeFromBreakpointM="display-3"
          >
            {t('hero--title')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            {t('hero--text')}
          </Typography>
        </div>
        <HeroGrid />
      </div>
    </PitchPageLayout>
  );
};

export default Hero;
